import { Box, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, IconButton, Dialog, DialogTitle, DialogContent, Chip, Button, FormControlLabel, Checkbox, CircularProgress, Pagination } from '@mui/material';
import { useEffect, useState } from 'react';
import { IconCopy, IconInfoSquareRounded, IconTrash } from '@tabler/icons-react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import 'react-medium-image-zoom/dist/styles.css'; // Import the default styles for zoom
import Zoom from 'react-medium-image-zoom'; // Importing the zoom library

import { useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import dayjs from "dayjs";
import { usePostBodyWithJwtMutation } from 'src/redux/api/cabinet';
import { updBalances } from 'src/redux/slices/app';
import { Alerting } from 'src/views/components_cabinet/Alerting';
import { palette } from 'src/theme/style/palette';
import { ReturnNumber } from 'src/components/return-balance/ReturnNumber';
import { ReturnBalance } from 'src/components/return-balance/ReturnBalance';
import { AddNewAdsButton } from './AddNewAdsButton';

dayjs.locale("ru");

export const P2pMoiObyavleniyaPage = () => {
    const [openModalRequisiteCreate, setOpenModalRequisiteCreate] = useState<boolean>(false);
    const [checkAds, setCheckAds] = useState<any>({});
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const nav = useNavigate();
    const [items, setItems] = useState<any[]>([]);
    const [lastPage, setLastPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [typeModalState, setTypeModalState] = useState('');
    const dispatch = useDispatch();

    const handleCopyClick = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setgetAlert({ type: 1, msg: 'Скопировано' });

        } catch (err) {
            setgetAlert({ type: 2, msg: "Не удалось скопировать" });
        }
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmation(event.target.checked);
    };

    const openModalAds = (e: any, type = 'update') => {
        setTypeModalState(type);
        setOpenModalRequisiteCreate(true);
        setCheckAds(e)
    }

    const closeModalAds = () => {
        setOpenModalRequisiteCreate(false)
        setCheckAds({})
        setConfirmation(false)
    }

    const [postData, { isSuccess, isLoading }] = usePostBodyWithJwtMutation();
    const registerAnswer = async (body: any = {}) => {
        const route = "p2p-my";
        const jwt = localStorage.getItem("jwt");
        await postData({ body, route, jwt })
            .unwrap()
            .then((payload: any) => {
                setItems(payload.data.data);
                setLastPage(payload.data?.last_page || 1);
                setCurrentPage(payload.data?.current_page || 1);
            })
            .catch((error: any) => {
                if (error.status == 401) nav("/login");
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const [postDataAdd, { isLoading: loadDel }] = usePostBodyWithJwtMutation();
    const registerAnswerAdd = async (body: any = {}) => {
        const route = "p2p-add";
        const jwt = localStorage.getItem("jwt");
        await postDataAdd({ body, route, jwt })
            .unwrap()
            .then((payload: any) => {
                requestExchanges();
                closeModalAds();
                if (payload?.data?.balance) {
                    dispatch(updBalances(payload?.data));
                }
                setgetAlert({ type: 1, msg: payload.message });
            })
            .catch((error: any) => {
                if (error.status == 401) nav("/login");
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const [postDataConfirm, { isLoading: loadConfirm }] = usePostBodyWithJwtMutation();
    const registerAnswerConfirm = async (body: any = {}) => {
        const route = "confirmation-sales";
        const jwt = localStorage.getItem("jwt");
        await postDataConfirm({ body, route, jwt })
            .unwrap()
            .then((payload: any) => {
                requestExchanges();
                closeModalAds();
                if (payload?.data?.balance) {
                    dispatch(updBalances(payload?.data));
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                }
                setgetAlert({ type: 1, msg: payload.message });
            })
            .catch((error: any) => {
                if (error.status == 401) nav("/login");
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const requestExchanges = (page = 1) => {
        registerAnswer({
            owner: true,
            page,
        });
    }

    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        requestExchanges(value);
    };

    useEffect(() => {
        registerAnswer()
    }, []);

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}
            <>
                <Card sx={{ p: 0 }}>
                    <CardContent sx={{ position: 'relative' }}>
                        <Box>
                            <Typography variant="h6" mb={3}>
                                Мои объявления
                            </Typography>
                            <AddNewAdsButton />
                        </Box>

                        {!isLoading && isSuccess && items?.length > 0 &&
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: 'none', minHeight: '360px' }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><Typography variant='h6'>№</Typography></TableCell>
                                                <TableCell><Typography variant='h6'>Сумма продажи</Typography></TableCell>
                                                <TableCell><Typography variant='h6'>Валюта</Typography></TableCell>
                                                <TableCell><Typography variant='h6'>Банк</Typography></TableCell>
                                                <TableCell><Typography variant='h6'>Статус</Typography></TableCell>
                                                <TableCell><Typography variant='h6'>Опубликовано</Typography></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {items?.map((ad: any, i) => {
                                                const isAwaitingConfirmation = ad.status_id === 'Ожидает подтверждения';
                                                return (
                                                    <TableRow
                                                        key={ad.id}
                                                        sx={{
                                                            backgroundColor: i % 2 === 0 ? palette.lightGray : palette.blueLight,
                                                            transition: 'background-color 0.3s ease',
                                                        }}
                                                    >

                                                        <TableCell><Typography variant='h6'>{i + 1}</Typography></TableCell>
                                                        <TableCell>
                                                            <Typography variant='h6'>
                                                                <ReturnBalance num={ad.amount} />
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            <Typography variant='h6'>
                                                                {ad.currency}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='h6'>
                                                                {ad.bank}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>

                                                            {isAwaitingConfirmation ? (
                                                                <Box
                                                                    sx={{
                                                                        display: 'inline-block',
                                                                        backgroundColor: palette.error,
                                                                        color: 'white',
                                                                        padding: '5px 10px',
                                                                        borderRadius: '12px',
                                                                        cursor: 'pointer',
                                                                        fontWeight: 'bold',
                                                                        textAlign: 'center',
                                                                        animation: 'pulse 1.5s ease-in-out infinite',
                                                                    }}
                                                                >
                                                                    Ждёт подтверждения
                                                                </Box>
                                                            ) : (
                                                                <Chip sx={{ fontSize: '16px' }} label={
                                                                    ad.status_id
                                                                }
                                                                />

                                                            )}

                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>{ad.created_at ? dayjs(ad.created_at).format("DD MMM YYYY, HH:mm") : "Неизвестно"}</TableCell>
                                                        <TableCell>

                                                            {/* <pre>
                                                                {JSON.stringify(ad, null, 2)}
                                                            </pre> */}

                                                            {ad.status_id == 'Продается' &&
                                                                <IconButton onClick={() => openModalAds(ad, 'delete')}
                                                                    sx={{
                                                                        background: palette.error, "&:hover>svg": {
                                                                            color: `${palette.error} !important`
                                                                        }
                                                                    }}
                                                                >
                                                                    <IconTrash style={{ color: "#fff" }} />
                                                                </IconButton>
                                                            }

                                                            {isAwaitingConfirmation &&
                                                                <IconButton onClick={() => openModalAds(ad)} sx={{ background: palette.error }}>
                                                                    <IconInfoSquareRounded style={{ width: 30, height: 30, color: '#fff' }} />
                                                                </IconButton>
                                                            }

                                                            {ad.status_id == 'Забронирован' &&
                                                                <Typography variant='body1'>
                                                                    Ждем оплату
                                                                </Typography>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Box my={1}>
                                    <Pagination
                                        count={lastPage}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                    />
                                </Box>
                            </>
                        }

                        {isLoading && <Box sx={{
                            minHeight: '360px', display: 'flex', justifyContent: 'center', alignItems: 'center'
                        }}>
                            <CircularProgress sx={{ color: `${palette.blue} !important` }} />
                        </Box>}

                        {items.length === 0 && !isLoading && (
                            <Box display="flex" justifyContent="center" alignItems="center" minHeight={360}>
                                <Typography variant="h4" textAlign="center">
                                    Нет текущих объявлений
                                </Typography>
                            </Box>
                        )}

                    </CardContent>
                </Card>

                <Dialog fullWidth={true} maxWidth="lg" open={openModalRequisiteCreate} onClose={closeModalAds}>
                    <IconButton sx={{ background: palette.errorLight, position: 'absolute', top: '.5rem', right: '.5rem' }}
                        onClick={() => setOpenModalRequisiteCreate(false)}>
                        <CloseRoundedIcon sx={{ color: palette.error }} />
                    </IconButton>
                    <DialogTitle>Данные объявления</DialogTitle>
                    <DialogContent sx={{ position: 'relative' }}>
                        <Box minHeight={300} pb={3}>
                            {typeModalState == 'update' ?
                                <>
                                    <Box display='flex' alignItems='center' justifyContent='space-between'>
                                        <Box display='flex' alignItems='center'>
                                            <Typography variant='body1' sx={{ fontWeight: 600, mr: 1 }}><span style={{ fontWeight: 300 }}>ID:</span>&nbsp;{checkAds?.id}</Typography>
                                            <IconButton size='small' onClick={() => handleCopyClick(checkAds?.id)}>
                                                <IconCopy style={{ width: '17px' }} />
                                            </IconButton>
                                        </Box>
                                        <Box>
                                            {checkAds.status_id === 'Ждёт подтверждения' ? (
                                                <Box
                                                    sx={{
                                                        display: 'inline-block',
                                                        backgroundColor: palette.error,
                                                        color: 'white',
                                                        padding: '5px 10px',
                                                        borderRadius: '12px',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        textAlign: 'center',
                                                        fontSize: '13px',
                                                        animation: 'pulse 1.5s ease-in-out infinite',
                                                    }}
                                                >
                                                    {checkAds.status_id}
                                                </Box>
                                            ) : (
                                                <Chip
                                                    label={<Typography variant='body2' sx={{ fontWeight: 600 }}>
                                                        {checkAds.status_id}
                                                    </Typography>}
                                                />
                                            )}
                                        </Box>

                                    </Box>

                                    <Box display='flex' justifyContent='center'>
                                        <Box>
                                            <Typography textAlign='center' variant='h4'>Продается <Box component='span' sx={{ fontWeight: 600 }}><ReturnNumber num={checkAds.amount} /> </Box></Typography>
                                            <Typography textAlign='center' variant='h6'>Сумма в валюте <Box component='span' sx={{ fontWeight: 600 }}><ReturnNumber num={checkAds.amount * checkAds.value} /> {checkAds.currency}</Box></Typography>

                                            <Box width='100%' mt={2}>
                                                {/* Wrap the image with Zoom component */}
                                                <Zoom>
                                                    <img style={{ width: '100%', height: '800px', objectFit: 'contain' }} src={checkAds?.path} alt="test" />
                                                </Zoom>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ position: 'sticky', bottom: 0, left: 0, right: 0, background: '#ffffffd1', py: 1 }} width='100%' mt={3} display='inline-flex' justifyContent='center' alignItems='center' flexDirection='column'>
                                        <FormControlLabel
                                            control={<Checkbox checked={confirmation} onChange={handleChange} />}
                                            label="Я получил платеж от покупателя на свои реквизиты"
                                        />

                                        <Button sx={{ mt: 1 }}
                                            variant='contained'
                                            disabled={!confirmation || loadConfirm}
                                            onClick={() => {
                                                registerAnswerConfirm({
                                                    exchange: checkAds.id
                                                })
                                            }}
                                        >
                                            Подтверждаю перевод
                                        </Button>
                                    </Box>
                                </>
                                :
                                <>
                                    <Typography variant='h5' textAlign='center'>
                                        Вы уверены что хотите удалить объявление?
                                    </Typography>

                                    <Box my={3}>
                                        <Typography variant='body1' textAlign='center'>
                                            После удаления объявления, вы не сможете его восстановить.
                                        </Typography>
                                        <Typography variant='h6' textAlign='center'>
                                            Сумма продажи: <Box sx={{ fontWeight: 'bold' }} component="span">
                                                <ReturnBalance num={checkAds.amount} />
                                            </Box>
                                        </Typography>

                                    </Box>

                                    {/* {"id":9,"user_id":4,"receiver_id":0,"amount":11,"currency":"EUR - Евро","account":"КАСПИ","status_id":"Продается","final_at":null,"created_at":"2025-02-13T19:07:22.000000Z","updated_at":"2025-02-13T19:07:22.000000Z","currency_id":"EUR","value":0.00987905} */}


                                    {checkAds.status_id !== 'Продается' ?
                                        <>
                                            <Box display='flex' justifyContent='center'>
                                                <Chip
                                                    label={<Box component='span'>
                                                        Нельзя удаляь в статусе&nbsp;
                                                        <Typography component='span' sx={{ color: palette.error, textTransform: 'uppercase' }}>
                                                            {checkAds.status_id}
                                                        </Typography>
                                                    </Box>}
                                                />
                                            </Box>
                                        </> :
                                        <Typography variant='h6' textAlign='center'>
                                            {checkAds.status_id}
                                        </Typography>
                                    }

                                    <Box display='flex' alignItems='center' justifyContent='center' mt={3}>
                                        <Button
                                            onClick={() => {
                                                registerAnswerAdd({
                                                    del: true,
                                                    exchange_id: checkAds.id
                                                })
                                            }}
                                            disabled={checkAds.status_id !== 'Продается' || loadDel}
                                            sx={{ mt: 1 }}
                                            variant='contained'
                                            color='error'>
                                            Подтверждаю удаление
                                        </Button>
                                    </Box>
                                </>
                            }

                        </Box>
                    </DialogContent>
                </Dialog>
            </>

            <style>
                {`
                    @keyframes pulse {
                    0% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.1);
                        opacity: 0.8;
                    }
                    100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    }
                `}
            </style>
        </>
    )
}
